<template>
  <v-dialog persistent width="750" v-model="dialogOpen">
    <v-card>
      <v-card-title>Customer Details</v-card-title>

      <v-card-text>
        <v-row class="mb-n6">
          <v-col>
            <v-text-field v-model="business_name" label="Business Name" :disabled="formLoading" outlined dense required></v-text-field>
          </v-col>
          <v-col>
            <v-text-field v-model="customer_name" label="Customer Name" :disabled="formLoading" outlined dense required></v-text-field>
          </v-col>
        </v-row>

        <v-row class="mb-n6">
          <v-col>
            <v-text-field v-model="mobile_phone" label="Mobile Phone" :disabled="formLoading" outlined dense required></v-text-field>
          </v-col>
          <v-col>
            <v-text-field v-model="customer_phone" label="Customer Phone" :disabled="formLoading" outlined dense required></v-text-field>
          </v-col>
        </v-row>

        <v-row class="mb-n6">
          <v-col>
            <v-text-field v-model="email_address" label="Email Address" :disabled="formLoading" outlined dense required></v-text-field>
          </v-col>
          <v-col>
            <v-text-field v-model="address_post_code" label="Post Code" :disabled="formLoading" outlined dense required></v-text-field>
          </v-col>
        </v-row>

        <v-row class="mb-n6">
          <v-col>
            <v-autocomplete v-model="industry" label="Industry" :items="getLeadIndustries" :disabled="formLoading" :loading="getFetchLeadIndustriesLoading" outlined dense required></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field v-model="industry_description" label="Industry Description" counter maxlength="150" :disabled="formLoading" outlined dense></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>
      
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="save" :disabled="formLoading" :loading="formLoading">Save</v-btn>
        <v-btn color="primary" outlined small @click="close">cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters,mapActions,mapState } from "vuex";

  export default {
    props: {
      dialogOpen: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        business_name: '',
        customer_name: '',
        mobile_phone: '',
        customer_phone: '',
        email_address: '',
        address_post_code: '',
        industry: '',
        industry_description: '',
        formLoading: false,
      }
    },

    computed: {
      ...mapState('leads',['currentLead']),
      ...mapGetters('leads',['getLeadIndustries','getLeadProviders', 'getFetchLeadIndustriesLoading']),
    },

    watch: {
      dialogOpen(val) {
        if(val){
          this.fetchLeadIndustries();

          this.customer_name = this.currentLead.contact.name;
          this.customer_phone = this.currentLead.contact.phone_number;
          this.mobile_phone = this.currentLead.contact.mobile_number;
          this.email_address = this.currentLead.contact.email_address;

          this.business_name = this.currentLead.business_name;
          this.address_post_code = this.currentLead.address_post_code;
          this.industry = this.currentLead.industry;
          this.industry_description = this.currentLead.industry_description;
        }
      }
    },
    
    methods: {
      ...mapActions('leads',['updateLeadCustomer', 'fetchLeadIndustries']),

      close() {
        this.$emit('close-dialog');
      },

      async save() {
        this.formLoading = true;
        let data = {
          id: this.currentLead.id,
          data: {
            contact: {
              name: this.customer_name,
              phone_number: this.customer_phone,
              mobile_number: this.mobile_phone,
              email_address: this.email_address,
            },
            business_name: this.business_name,
            address_post_code: this.address_post_code,
            industry: this.industry,
            industry_description: this.industry_description,
          }
        };

        try{
          await this.updateLeadCustomer({sentData: data});
          this.formLoading = false;
          this.close();
        }catch(error){
          this.formLoading = false;
        }
      },
    }
  }
</script>

<style lang="scss" scoped></style>
